// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__3E7T5","title":"InfoRow_title__27PO6"};